<div class="chart" @mouseleave="hideTooltip"><echarts class="echarts" ref="chart" :options="valueFinal" autoresize @click="handleDrilldown"></echarts></div>